define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    exports["default"] = [
        {
            "name": "CC-30 Oxford White",
            "value": "hsl(69,21%,94%)",
            "hsl": [
                69,
                21,
                94
            ],
            "rgb": "#f1f2eb"
        },
        {
            "name": "CC-10 Ultra White",
            "value": "hsl(120,6%,93%)",
            "hsl": [
                120,
                6,
                93
            ],
            "rgb": "#edefed"
        },
        {
            "name": "CC-20 Decorator's White",
            "value": "hsl(100,8%,93%)",
            "hsl": [
                100,
                8,
                93
            ],
            "rgb": "#eceeeb"
        },
        {
            "name": "CC-40 Cloud White",
            "value": "hsl(55,33%,93%)",
            "hsl": [
                55,
                33,
                93
            ],
            "rgb": "#f3f2e7"
        },
        {
            "name": "CC-100 Flurry",
            "value": "hsl(43,57%,93%)",
            "hsl": [
                43,
                57,
                93
            ],
            "rgb": "#f7f1e2"
        },
        {
            "name": "CC-130 Ivory White",
            "value": "hsl(51,44%,92%)",
            "hsl": [
                51,
                44,
                92
            ],
            "rgb": "#f3f0e0"
        },
        {
            "name": "CC-70 Dune White",
            "value": "hsl(50,25%,91%)",
            "hsl": [
                50,
                25,
                91
            ],
            "rgb": "#edebe1"
        },
        {
            "name": "CC-160 White Rock",
            "value": "hsl(46,62%,91%)",
            "hsl": [
                46,
                62,
                91
            ],
            "rgb": "#f6efd9"
        },
        {
            "name": "CC-156 Tofino Sunset",
            "value": "hsl(18,55%,79%)",
            "hsl": [
                18,
                55,
                79
            ],
            "rgb": "#e7bead"
        },
        {
            "name": "CC-8 Frosted Berry",
            "value": "hsl(8,20%,69%)",
            "hsl": [
                8,
                20,
                69
            ],
            "rgb": "#c0a5a1"
        },
        {
            "name": "CC-154 Smoked Salmon",
            "value": "hsl(14,39%,61%)",
            "hsl": [
                14,
                39,
                61
            ],
            "rgb": "#c28674"
        },
        {
            "name": "CC-184 Bed and Breakfast",
            "value": "hsl(17,39%,61%)",
            "hsl": [
                17,
                39,
                61
            ],
            "rgb": "#c28973"
        },
        {
            "name": "CC-6 Muskoka Dusk",
            "value": "hsl(355,12%,59%)",
            "hsl": [
                355,
                12,
                59
            ],
            "rgb": "#a38a8c"
        },
        {
            "name": "CC-128 Red Point Sand",
            "value": "hsl(12,38%,53%)",
            "hsl": [
                12,
                38,
                53
            ],
            "rgb": "#b46a58"
        },
        {
            "name": "CC-96 Flower Pot",
            "value": "hsl(16,42%,53%)",
            "hsl": [
                16,
                42,
                53
            ],
            "rgb": "#b96e53"
        },
        {
            "name": "CC-98 Prairie Lily",
            "value": "hsl(14,47%,52%)",
            "hsl": [
                14,
                47,
                52
            ],
            "rgb": "#be6549"
        },
        {
            "name": "CC-126 Covered Bridge",
            "value": "hsl(8,36%,48%)",
            "hsl": [
                8,
                36,
                48
            ],
            "rgb": "#a65a4f"
        },
        {
            "name": "CC-94 Northern Fire",
            "value": "hsl(5,42%,46%)",
            "hsl": [
                5,
                42,
                46
            ],
            "rgb": "#a74d44"
        },
        {
            "name": "CC-64 Bonaparte",
            "value": "hsl(0,43%,44%)",
            "hsl": [
                0,
                43,
                44
            ],
            "rgb": "#a03f3f"
        },
        {
            "name": "CC-68 Lyons Red",
            "value": "hsl(355,49%,44%)",
            "hsl": [
                355,
                49,
                44
            ],
            "rgb": "#a73942"
        },
        {
            "name": "CC-122 Boxcar Red",
            "value": "hsl(6,32%,43%)",
            "hsl": [
                6,
                32,
                43
            ],
            "rgb": "#8f514a"
        },
        {
            "name": "CC-92 Spanish Red",
            "value": "hsl(5,40%,43%)",
            "hsl": [
                5,
                40,
                43
            ],
            "rgb": "#994942"
        },
        {
            "name": "CC-484 Hot Chocolate",
            "value": "hsl(19,26%,42%)",
            "hsl": [
                19,
                26,
                42
            ],
            "rgb": "#876150"
        },
        {
            "name": "CC-66 Rapture",
            "value": "hsl(353,54%,40%)",
            "hsl": [
                353,
                54,
                40
            ],
            "rgb": "#9d2f3c"
        },
        {
            "name": "CC-152 Laurentian Red",
            "value": "hsl(4,28%,39%)",
            "hsl": [
                4,
                28,
                39
            ],
            "rgb": "#7f4b47"
        },
        {
            "name": "CC-124 Louisiana Hot Sauce",
            "value": "hsl(10,49%,38%)",
            "hsl": [
                10,
                49,
                38
            ],
            "rgb": "#8f4031"
        },
        {
            "name": "CC-62 Sundried Tomato",
            "value": "hsl(4,39%,34%)",
            "hsl": [
                4,
                39,
                34
            ],
            "rgb": "#793a35"
        },
        {
            "name": "CC-32 Radicchio",
            "value": "hsl(346,33%,31%)",
            "hsl": [
                346,
                33,
                31
            ],
            "rgb": "#6a3642"
        },
        {
            "name": "CC-2 Raphael",
            "value": "hsl(5,24%,28%)",
            "hsl": [
                5,
                24,
                28
            ],
            "rgb": "#593936"
        },
        {
            "name": "CC-158 Pink Moiré",
            "value": "hsl(22,61%,88%)",
            "hsl": [
                22,
                61,
                88
            ],
            "rgb": "#f3dbcd"
        },
        {
            "name": "CC-428 Ice Breaker",
            "value": "hsl(35,34%,86%)",
            "hsl": [
                35,
                34,
                86
            ],
            "rgb": "#e8ded0"
        },
        {
            "name": "CC-340 Lambskin",
            "value": "hsl(38,42%,85%)",
            "hsl": [
                38,
                42,
                85
            ],
            "rgb": "#e9ddc9"
        },
        {
            "name": "CC-140 Barely Beige",
            "value": "hsl(40,46%,85%)",
            "hsl": [
                40,
                46,
                85
            ],
            "rgb": "#eadec6"
        },
        {
            "name": "CC-426 Bone China",
            "value": "hsl(30,21%,83%)",
            "hsl": [
                30,
                21,
                83
            ],
            "rgb": "#ddd4cb"
        },
        {
            "name": "CC-60 Brandy Cream",
            "value": "hsl(34,36%,83%)",
            "hsl": [
                34,
                36,
                83
            ],
            "rgb": "#e3d5c3"
        },
        {
            "name": "CC-310 Dusty Road",
            "value": "hsl(32,32%,82%)",
            "hsl": [
                32,
                32,
                82
            ],
            "rgb": "#dfd1c1"
        },
        {
            "name": "CC-110 Muslin",
            "value": "hsl(39,36%,82%)",
            "hsl": [
                39,
                36,
                82
            ],
            "rgb": "#e2d7c2"
        },
        {
            "name": "CC-278 Kitsilano Beach",
            "value": "hsl(35,59%,81%)",
            "hsl": [
                35,
                59,
                81
            ],
            "rgb": "#ebd3b2"
        },
        {
            "name": "CC-400 Sundial",
            "value": "hsl(37,59%,81%)",
            "hsl": [
                37,
                59,
                81
            ],
            "rgb": "#ebd5b1"
        },
        {
            "name": "CC-370 Sea Urchin",
            "value": "hsl(35,43%,80%)",
            "hsl": [
                35,
                43,
                80
            ],
            "rgb": "#e2d0b6"
        },
        {
            "name": "CC-306 Cable Knit",
            "value": "hsl(40,46%,80%)",
            "hsl": [
                40,
                46,
                80
            ],
            "rgb": "#e3d3b4"
        },
        {
            "name": "CC-458 Mocha Cream",
            "value": "hsl(33,20%,79%)",
            "hsl": [
                33,
                20,
                79
            ],
            "rgb": "#d4cabe"
        },
        {
            "name": "CC-308 Thousand Islands",
            "value": "hsl(37,38%,79%)",
            "hsl": [
                37,
                38,
                79
            ],
            "rgb": "#ddcdb4"
        },
        {
            "name": "CC-430 Moccasin",
            "value": "hsl(37,42%,79%)",
            "hsl": [
                37,
                42,
                79
            ],
            "rgb": "#e0cfb4"
        },
        {
            "name": "CC-188 Butter Rum",
            "value": "hsl(30,74%,79%)",
            "hsl": [
                30,
                74,
                79
            ],
            "rgb": "#f1caa2"
        },
        {
            "name": "CC-424 Old Stone",
            "value": "hsl(24,23%,78%)",
            "hsl": [
                24,
                23,
                78
            ],
            "rgb": "#d4c5bb"
        },
        {
            "name": "CC-244 French Toast",
            "value": "hsl(38,65%,78%)",
            "hsl": [
                38,
                65,
                78
            ],
            "rgb": "#ebd0a1"
        },
        {
            "name": "CC-212 Danse du Soleil",
            "value": "hsl(40,91%,78%)",
            "hsl": [
                40,
                91,
                78
            ],
            "rgb": "#fad896"
        },
        {
            "name": "CC-350 Sycamore",
            "value": "hsl(29,53%,77%)",
            "hsl": [
                29,
                53,
                77
            ],
            "rgb": "#e4c4a7"
        },
        {
            "name": "CC-460 Inukshuk",
            "value": "hsl(38,20%,76%)",
            "hsl": [
                38,
                20,
                76
            ],
            "rgb": "#cec5b6"
        },
        {
            "name": "CC-368 Sandpiper Beige",
            "value": "hsl(30,35%,76%)",
            "hsl": [
                30,
                35,
                76
            ],
            "rgb": "#d8c3ae"
        },
        {
            "name": "CC-456 Dufferin Terrace",
            "value": "hsl(35,20%,74%)",
            "hsl": [
                35,
                20,
                74
            ],
            "rgb": "#cabfb0"
        },
        {
            "name": "CC-396 Stone Castle",
            "value": "hsl(31,21%,74%)",
            "hsl": [
                31,
                21,
                74
            ],
            "rgb": "#cbbeb0"
        },
        {
            "name": "CC-422 Pink Pebble",
            "value": "hsl(23,24%,74%)",
            "hsl": [
                23,
                24,
                74
            ],
            "rgb": "#cdbaae"
        },
        {
            "name": "CC-394 Boulevard",
            "value": "hsl(29,15%,73%)",
            "hsl": [
                29,
                15,
                73
            ],
            "rgb": "#c4b9af"
        },
        {
            "name": "CC-398 Old Montreal",
            "value": "hsl(30,25%,73%)",
            "hsl": [
                30,
                25,
                73
            ],
            "rgb": "#cbbaa9"
        },
        {
            "name": "CC-320 Bar Harbor Beige",
            "value": "hsl(33,31%,73%)",
            "hsl": [
                33,
                31,
                73
            ],
            "rgb": "#d0bda5"
        },
        {
            "name": "CC-150 Sandy Brown",
            "value": "hsl(39,39%,73%)",
            "hsl": [
                39,
                39,
                73
            ],
            "rgb": "#d4c19e"
        },
        {
            "name": "CC-276 Sepia Tan",
            "value": "hsl(34,48%,73%)",
            "hsl": [
                34,
                48,
                73
            ],
            "rgb": "#dbbe99"
        },
        {
            "name": "CC-242 Maple Fudge",
            "value": "hsl(38,64%,73%)",
            "hsl": [
                38,
                64,
                73
            ],
            "rgb": "#e6c58c"
        },
        {
            "name": "CC-490 Stone Hearth",
            "value": "hsl(37,18%,72%)",
            "hsl": [
                37,
                18,
                72
            ],
            "rgb": "#c5bbab"
        },
        {
            "name": "CC-120 Stone House",
            "value": "hsl(35,35%,72%)",
            "hsl": [
                35,
                35,
                72
            ],
            "rgb": "#d0bb9d"
        },
        {
            "name": "CC-210 Dijon",
            "value": "hsl(38,60%,72%)",
            "hsl": [
                38,
                60,
                72
            ],
            "rgb": "#e2c38c"
        },
        {
            "name": "CC-366 Nubuck",
            "value": "hsl(28,32%,70%)",
            "hsl": [
                28,
                32,
                70
            ],
            "rgb": "#cab099"
        },
        {
            "name": "CC-186 Indian Summer",
            "value": "hsl(25,56%,70%)",
            "hsl": [
                25,
                56,
                70
            ],
            "rgb": "#ddab87"
        },
        {
            "name": "CC-338 Bluffs",
            "value": "hsl(35,33%,69%)",
            "hsl": [
                35,
                33,
                69
            ],
            "rgb": "#cab495"
        },
        {
            "name": "CC-410 Boardwalk",
            "value": "hsl(34,49%,69%)",
            "hsl": [
                34,
                49,
                69
            ],
            "rgb": "#d6b488"
        },
        {
            "name": "CC-380 Toffee Cream",
            "value": "hsl(28,46%,68%)",
            "hsl": [
                28,
                46,
                68
            ],
            "rgb": "#d3ac89"
        },
        {
            "name": "CC-454 Cobblestone",
            "value": "hsl(29,16%,67%)",
            "hsl": [
                29,
                16,
                67
            ],
            "rgb": "#b8aa9d"
        },
        {
            "name": "CC-488 Biscotti",
            "value": "hsl(31,35%,67%)",
            "hsl": [
                31,
                35,
                67
            ],
            "rgb": "#c9ad8f"
        },
        {
            "name": "CC-470 Rocky Road",
            "value": "hsl(33,17%,66%)",
            "hsl": [
                33,
                17,
                66
            ],
            "rgb": "#b8ab9b"
        },
        {
            "name": "CC-304 Sisal",
            "value": "hsl(34,39%,66%)",
            "hsl": [
                34,
                39,
                66
            ],
            "rgb": "#caad87"
        },
        {
            "name": "CC-330 Hillsborough Beige",
            "value": "hsl(32,27%,65%)",
            "hsl": [
                32,
                27,
                65
            ],
            "rgb": "#bda78d"
        },
        {
            "name": "CC-440 Capilano Bridge",
            "value": "hsl(34,31%,65%)",
            "hsl": [
                34,
                31,
                65
            ],
            "rgb": "#c1a888"
        },
        {
            "name": "CC-500 Ranchwood",
            "value": "hsl(37,15%,63%)",
            "hsl": [
                37,
                15,
                63
            ],
            "rgb": "#aea391"
        },
        {
            "name": "CC-392 Muddy York",
            "value": "hsl(23,21%,63%)",
            "hsl": [
                23,
                21,
                63
            ],
            "rgb": "#b59d8e"
        },
        {
            "name": "CC-364 Shore Line",
            "value": "hsl(29,22%,63%)",
            "hsl": [
                29,
                22,
                63
            ],
            "rgb": "#b5a08c"
        },
        {
            "name": "CC-518 Escarpment",
            "value": "hsl(35,6%,62%)",
            "hsl": [
                35,
                6,
                62
            ],
            "rgb": "#a39e97"
        },
        {
            "name": "CC-336 Wild Mushroom",
            "value": "hsl(34,27%,62%)",
            "hsl": [
                34,
                27,
                62
            ],
            "rgb": "#b9a284"
        },
        {
            "name": "CC-274 Ginger Root",
            "value": "hsl(34,46%,62%)",
            "hsl": [
                34,
                46,
                62
            ],
            "rgb": "#cba573"
        },
        {
            "name": "CC-604 Turret",
            "value": "hsl(38,17%,61%)",
            "hsl": [
                38,
                17,
                61
            ],
            "rgb": "#ac9f89"
        },
        {
            "name": "CC-486 Tiramisu",
            "value": "hsl(29,28%,60%)",
            "hsl": [
                29,
                28,
                60
            ],
            "rgb": "#b5977b"
        },
        {
            "name": "CC-302 Rawhide",
            "value": "hsl(30,32%,60%)",
            "hsl": [
                30,
                32,
                60
            ],
            "rgb": "#ba9a79"
        },
        {
            "name": "CC-334 Great Plains",
            "value": "hsl(33,26%,59%)",
            "hsl": [
                33,
                26,
                59
            ],
            "rgb": "#b1997b"
        },
        {
            "name": "CC-182 Frontenac Brick",
            "value": "hsl(22,37%,59%)",
            "hsl": [
                22,
                37,
                59
            ],
            "rgb": "#bd8c6f"
        },
        {
            "name": "CC-360 Potters Clay",
            "value": "hsl(24,38%,57%)",
            "hsl": [
                24,
                38,
                57
            ],
            "rgb": "#ba8867"
        },
        {
            "name": "CC-452 Deer Granite",
            "value": "hsl(28,15%,56%)",
            "hsl": [
                28,
                15,
                56
            ],
            "rgb": "#9f8d7d"
        },
        {
            "name": "CC-480 Cabot Trail",
            "value": "hsl(31,16%,56%)",
            "hsl": [
                31,
                16,
                56
            ],
            "rgb": "#a08f7d"
        },
        {
            "name": "CC-576 Nordic Gray",
            "value": "hsl(37,16%,55%)",
            "hsl": [
                37,
                16,
                55
            ],
            "rgb": "#9f917a"
        },
        {
            "name": "CC-362 Elk",
            "value": "hsl(32,22%,55%)",
            "hsl": [
                32,
                22,
                55
            ],
            "rgb": "#a68e73"
        },
        {
            "name": "CC-420 Maple Syrup",
            "value": "hsl(31,39%,55%)",
            "hsl": [
                31,
                39,
                55
            ],
            "rgb": "#b98e61"
        },
        {
            "name": "CC-514 Hiking Trail",
            "value": "hsl(28,17%,54%)",
            "hsl": [
                28,
                17,
                54
            ],
            "rgb": "#9e8875"
        },
        {
            "name": "CC-332 Norwester Tan",
            "value": "hsl(35,27%,54%)",
            "hsl": [
                35,
                27,
                54
            ],
            "rgb": "#aa8f6a"
        },
        {
            "name": "CC-516 Flagstone",
            "value": "hsl(31,13%,53%)",
            "hsl": [
                31,
                13,
                53
            ],
            "rgb": "#978878"
        },
        {
            "name": "CC-546 Metropolis",
            "value": "hsl(32,6%,52%)",
            "hsl": [
                32,
                6,
                52
            ],
            "rgb": "#8c857d"
        },
        {
            "name": "CC-572 Barnboard",
            "value": "hsl(37,9%,50%)",
            "hsl": [
                37,
                9,
                50
            ],
            "rgb": "#8c8375"
        },
        {
            "name": "CC-574 Mortar",
            "value": "hsl(38,14%,49%)",
            "hsl": [
                38,
                14,
                49
            ],
            "rgb": "#8f826b"
        },
        {
            "name": "CC-540 Stampede",
            "value": "hsl(37,12%,47%)",
            "hsl": [
                37,
                12,
                47
            ],
            "rgb": "#867b69"
        },
        {
            "name": "CC-450 Caramel Apple",
            "value": "hsl(34,27%,47%)",
            "hsl": [
                34,
                27,
                47
            ],
            "rgb": "#9a7d58"
        },
        {
            "name": "CC-510 Buckhorn",
            "value": "hsl(33,17%,45%)",
            "hsl": [
                33,
                17,
                45
            ],
            "rgb": "#85745f"
        },
        {
            "name": "CC-272 Spiced Rum",
            "value": "hsl(27,36%,45%)",
            "hsl": [
                27,
                36,
                45
            ],
            "rgb": "#9d6f4a"
        },
        {
            "name": "CC-390 Rusty Nail",
            "value": "hsl(21,41%,44%)",
            "hsl": [
                21,
                41,
                44
            ],
            "rgb": "#9d6141"
        },
        {
            "name": "CC-544 Overcoat",
            "value": "hsl(30,1%,41%)",
            "hsl": [
                30,
                1,
                41
            ],
            "rgb": "#6a6968"
        },
        {
            "name": "CC-482 Chocolate Fondue",
            "value": "hsl(21,22%,37%)",
            "hsl": [
                21,
                22,
                37
            ],
            "rgb": "#735849"
        },
        {
            "name": "CC-512 Marshlands",
            "value": "hsl(33,15%,35%)",
            "hsl": [
                33,
                15,
                35
            ],
            "rgb": "#665a4b"
        },
        {
            "name": "CC-542 Willow",
            "value": "hsl(26,9%,31%)",
            "hsl": [
                26,
                9,
                31
            ],
            "rgb": "#574f49"
        },
        {
            "name": "CC-50 White Down",
            "value": "hsl(45,34%,89%)",
            "hsl": [
                45,
                34,
                89
            ],
            "rgb": "#ece7d8"
        },
        {
            "name": "CC-220 Wheat Sheaf",
            "value": "hsl(45,48%,87%)",
            "hsl": [
                45,
                48,
                87
            ],
            "rgb": "#eee6cf"
        },
        {
            "name": "CC-216 Butter Milk",
            "value": "hsl(43,91%,87%)",
            "hsl": [
                43,
                91,
                87
            ],
            "rgb": "#fcecc2"
        },
        {
            "name": "CC-80 Gray Mist",
            "value": "hsl(46,24%,86%)",
            "hsl": [
                46,
                24,
                86
            ],
            "rgb": "#e4e0d3"
        },
        {
            "name": "CC-170 Honey Harbor",
            "value": "hsl(43,63%,86%)",
            "hsl": [
                43,
                63,
                86
            ],
            "rgb": "#f2e5c5"
        },
        {
            "name": "CC-218 Corn Silk",
            "value": "hsl(48,97%,85%)",
            "hsl": [
                48,
                97,
                85
            ],
            "rgb": "#feefb3"
        },
        {
            "name": "CC-250 Seaspray",
            "value": "hsl(47,36%,83%)",
            "hsl": [
                47,
                36,
                83
            ],
            "rgb": "#e3dcc3"
        },
        {
            "name": "CC-190 Summer Harvest",
            "value": "hsl(44,63%,83%)",
            "hsl": [
                44,
                63,
                83
            ],
            "rgb": "#efe0b8"
        },
        {
            "name": "CC-246 Vichyssoise",
            "value": "hsl(45,43%,82%)",
            "hsl": [
                45,
                43,
                82
            ],
            "rgb": "#e4dabc"
        },
        {
            "name": "CC-248 Papaya",
            "value": "hsl(41,47%,82%)",
            "hsl": [
                41,
                47,
                82
            ],
            "rgb": "#e6d8ba"
        },
        {
            "name": "CC-280 Almond Bisque",
            "value": "hsl(44,49%,82%)",
            "hsl": [
                44,
                49,
                82
            ],
            "rgb": "#e8dcbc"
        },
        {
            "name": "CC-214 Golden Honey",
            "value": "hsl(43,92%,81%)",
            "hsl": [
                43,
                92,
                81
            ],
            "rgb": "#fbe2a1"
        },
        {
            "name": "CC-230 Delaware Putty",
            "value": "hsl(44,37%,80%)",
            "hsl": [
                44,
                37,
                80
            ],
            "rgb": "#ded4b8"
        },
        {
            "name": "CC-180 Barley",
            "value": "hsl(42,68%,79%)",
            "hsl": [
                42,
                68,
                79
            ],
            "rgb": "#eed8a5"
        },
        {
            "name": "CC-90 Natural Linen",
            "value": "hsl(41,29%,78%)",
            "hsl": [
                41,
                29,
                78
            ],
            "rgb": "#d8ceb8"
        },
        {
            "name": "CC-200 Vellum",
            "value": "hsl(42,62%,77%)",
            "hsl": [
                42,
                62,
                77
            ],
            "rgb": "#e9d4a2"
        },
        {
            "name": "CC-638 Sesame",
            "value": "hsl(54,43%,76%)",
            "hsl": [
                54,
                43,
                76
            ],
            "rgb": "#dcd7a8"
        },
        {
            "name": "CC-520 Florentine Plaster",
            "value": "hsl(46,20%,75%)",
            "hsl": [
                46,
                20,
                75
            ],
            "rgb": "#cbc5b1"
        },
        {
            "name": "CC-260 Butter Cream",
            "value": "hsl(43,36%,75%)",
            "hsl": [
                43,
                36,
                75
            ],
            "rgb": "#d6c9a7"
        },
        {
            "name": "CC-290 Straw Hat",
            "value": "hsl(43,43%,75%)",
            "hsl": [
                43,
                43,
                75
            ],
            "rgb": "#dacaa2"
        },
        {
            "name": "CC-578 Hemp Seed",
            "value": "hsl(42,31%,74%)",
            "hsl": [
                42,
                31,
                74
            ],
            "rgb": "#d2c6a9"
        },
        {
            "name": "CC-636 Mountain Air",
            "value": "hsl(54,15%,73%)",
            "hsl": [
                54,
                15,
                73
            ],
            "rgb": "#c5c3b1"
        },
        {
            "name": "CC-606 Spanish Olive",
            "value": "hsl(55,17%,73%)",
            "hsl": [
                55,
                17,
                73
            ],
            "rgb": "#c6c4af"
        },
        {
            "name": "CC-698 Killarney",
            "value": "hsl(60,14%,68%)",
            "hsl": [
                60,
                14,
                68
            ],
            "rgb": "#b9b9a2"
        },
        {
            "name": "CC-270 Baffin Island",
            "value": "hsl(44,26%,68%)",
            "hsl": [
                44,
                26,
                68
            ],
            "rgb": "#c2b798"
        },
        {
            "name": "CC-240 Late Wheat",
            "value": "hsl(43,37%,67%)",
            "hsl": [
                43,
                37,
                67
            ],
            "rgb": "#cbb98d"
        },
        {
            "name": "CC-300 Sombrero",
            "value": "hsl(43,43%,67%)",
            "hsl": [
                43,
                43,
                67
            ],
            "rgb": "#cfba86"
        },
        {
            "name": "CC-634 Herbes de Provence",
            "value": "hsl(50,16%,63%)",
            "hsl": [
                50,
                16,
                63
            ],
            "rgb": "#afaa90"
        },
        {
            "name": "CC-530 Brandon Beige",
            "value": "hsl(41,17%,63%)",
            "hsl": [
                41,
                17,
                63
            ],
            "rgb": "#b0a690"
        },
        {
            "name": "CC-590 Grasslands",
            "value": "hsl(64,22%,62%)",
            "hsl": [
                64,
                22,
                62
            ],
            "rgb": "#b0b389"
        },
        {
            "name": "CC-602 Stanley Park",
            "value": "hsl(51,13%,59%)",
            "hsl": [
                51,
                13,
                59
            ],
            "rgb": "#a4a088"
        },
        {
            "name": "CC-696 Taiga",
            "value": "hsl(49,9%,55%)",
            "hsl": [
                49,
                9,
                55
            ],
            "rgb": "#969280"
        },
        {
            "name": "CC-632 Bed of Ferns",
            "value": "hsl(48,15%,53%)",
            "hsl": [
                48,
                15,
                53
            ],
            "rgb": "#9a9376"
        },
        {
            "name": "CC-548 Asphalt",
            "value": "hsl(45,3%,49%)",
            "hsl": [
                45,
                3,
                49
            ],
            "rgb": "#807e78"
        },
        {
            "name": "CC-722 Vineland",
            "value": "hsl(63,9%,49%)",
            "hsl": [
                63,
                9,
                49
            ],
            "rgb": "#888973"
        },
        {
            "name": "CC-694 Tapenade",
            "value": "hsl(56,13%,47%)",
            "hsl": [
                56,
                13,
                47
            ],
            "rgb": "#868468"
        },
        {
            "name": "CC-664 Provincial Park",
            "value": "hsl(55,12%,37%)",
            "hsl": [
                55,
                12,
                37
            ],
            "rgb": "#6a6854"
        },
        {
            "name": "CC-666 Bonsai",
            "value": "hsl(64,20%,32%)",
            "hsl": [
                64,
                20,
                32
            ],
            "rgb": "#616342"
        },
        {
            "name": "CC-662 Night Owl",
            "value": "hsl(46,19%,30%)",
            "hsl": [
                46,
                19,
                30
            ],
            "rgb": "#5a533d"
        },
        {
            "name": "CC-608 Dewdrop",
            "value": "hsl(87,19%,89%)",
            "hsl": [
                87,
                19,
                89
            ],
            "rgb": "#e3e8dd"
        },
        {
            "name": "CC-580 Glazed Green",
            "value": "hsl(69,27%,81%)",
            "hsl": [
                69,
                27,
                81
            ],
            "rgb": "#d7dbc0"
        },
        {
            "name": "CC-700 Smoky Green",
            "value": "hsl(127,8%,80%)",
            "hsl": [
                127,
                8,
                80
            ],
            "rgb": "#c8d0c9"
        },
        {
            "name": "CC-640 Blue Grass",
            "value": "hsl(136,14%,79%)",
            "hsl": [
                136,
                14,
                79
            ],
            "rgb": "#c3d2c7"
        },
        {
            "name": "CC-610 Tea Light",
            "value": "hsl(85,16%,79%)",
            "hsl": [
                85,
                16,
                79
            ],
            "rgb": "#cad1c0"
        },
        {
            "name": "CC-670 Gray Wisp",
            "value": "hsl(98,9%,76%)",
            "hsl": [
                98,
                9,
                76
            ],
            "rgb": "#c0c7bc"
        },
        {
            "name": "CC-728 Maid of the Mist",
            "value": "hsl(104,12%,75%)",
            "hsl": [
                104,
                12,
                75
            ],
            "rgb": "#bcc7b8"
        },
        {
            "name": "CC-550 October Mist",
            "value": "hsl(66,12%,69%)",
            "hsl": [
                66,
                12,
                69
            ],
            "rgb": "#b7b9a6"
        },
        {
            "name": "CC-680 Raindance",
            "value": "hsl(135,7%,68%)",
            "hsl": [
                135,
                7,
                68
            ],
            "rgb": "#a8b4ab"
        },
        {
            "name": "CC-758 Scenic Drive",
            "value": "hsl(127,9%,65%)",
            "hsl": [
                127,
                9,
                65
            ],
            "rgb": "#9dad9f"
        },
        {
            "name": "CC-690 Piedmont Gray",
            "value": "hsl(142,6%,64%)",
            "hsl": [
                142,
                6,
                64
            ],
            "rgb": "#9ea9a2"
        },
        {
            "name": "CC-726 Nature Lover",
            "value": "hsl(72,12%,62%)",
            "hsl": [
                72,
                12,
                62
            ],
            "rgb": "#a6ab93"
        },
        {
            "name": "CC-650 Grenadier Pond",
            "value": "hsl(129,9%,61%)",
            "hsl": [
                129,
                9,
                61
            ],
            "rgb": "#91a494"
        },
        {
            "name": "CC-560 Raintree Green",
            "value": "hsl(66,10%,57%)",
            "hsl": [
                66,
                10,
                57
            ],
            "rgb": "#9b9d88"
        },
        {
            "name": "CC-620 High Park",
            "value": "hsl(99,9%,56%)",
            "hsl": [
                99,
                9,
                56
            ],
            "rgb": "#8d9a86"
        },
        {
            "name": "CC-724 Homestead",
            "value": "hsl(72,11%,55%)",
            "hsl": [
                72,
                11,
                55
            ],
            "rgb": "#949981"
        },
        {
            "name": "CC-668 Misted Fern",
            "value": "hsl(66,17%,53%)",
            "hsl": [
                66,
                17,
                53
            ],
            "rgb": "#979b73"
        },
        {
            "name": "CC-720 Night Train",
            "value": "hsl(150,4%,50%)",
            "hsl": [
                150,
                4,
                50
            ],
            "rgb": "#7b8580"
        },
        {
            "name": "CC-600 Mossy Oak",
            "value": "hsl(72,10%,46%)",
            "hsl": [
                72,
                10,
                46
            ],
            "rgb": "#7c8169"
        },
        {
            "name": "CC-660 Jack Pine",
            "value": "hsl(159,11%,40%)",
            "hsl": [
                159,
                11,
                40
            ],
            "rgb": "#5b726a"
        },
        {
            "name": "CC-570 Forest Floor",
            "value": "hsl(66,10%,36%)",
            "hsl": [
                66,
                10,
                36
            ],
            "rgb": "#636552"
        },
        {
            "name": "CC-630 Backwoods",
            "value": "hsl(95,9%,35%)",
            "hsl": [
                95,
                9,
                35
            ],
            "rgb": "#596352"
        },
        {
            "name": "CC-692 Topsoil",
            "value": "hsl(96,7%,27%)",
            "hsl": [
                96,
                7,
                27
            ],
            "rgb": "#43493f"
        },
        {
            "name": "CC-710 Mount Saint Anne",
            "value": "hsl(171,8%,67%)",
            "hsl": [
                171,
                8,
                67
            ],
            "rgb": "#a4b1af"
        },
        {
            "name": "CC-756 Avalon",
            "value": "hsl(178,13%,50%)",
            "hsl": [
                178,
                13,
                50
            ],
            "rgb": "#70908f"
        },
        {
            "name": "CC-754 Polar Jade",
            "value": "hsl(178,16%,37%)",
            "hsl": [
                178,
                16,
                37
            ],
            "rgb": "#4f6d6c"
        },
        {
            "name": "CC-752 Miramichi",
            "value": "hsl(185,21%,24%)",
            "hsl": [
                185,
                21,
                24
            ],
            "rgb": "#31494b"
        },
        {
            "name": "CC-910 Whirlpool",
            "value": "hsl(192,8%,88%)",
            "hsl": [
                192,
                8,
                88
            ],
            "rgb": "#dfe3e4"
        },
        {
            "name": "CC-790 Polar Sky",
            "value": "hsl(193,29%,85%)",
            "hsl": [
                193,
                29,
                85
            ],
            "rgb": "#ccdee3"
        },
        {
            "name": "CC-938 Ice Sculpture",
            "value": "hsl(211,36%,84%)",
            "hsl": [
                211,
                36,
                84
            ],
            "rgb": "#c8d6e5"
        },
        {
            "name": "CC-880 Violet Mist",
            "value": "hsl(212,16%,82%)",
            "hsl": [
                212,
                16,
                82
            ],
            "rgb": "#cad1d9"
        },
        {
            "name": "CC-788 Watercolor",
            "value": "hsl(196,33%,81%)",
            "hsl": [
                196,
                33,
                81
            ],
            "rgb": "#bdd5de"
        },
        {
            "name": "CC-850 Blue Ice",
            "value": "hsl(212,37%,81%)",
            "hsl": [
                212,
                37,
                81
            ],
            "rgb": "#bbcce0"
        },
        {
            "name": "CC-848 Mineral Springs",
            "value": "hsl(200,52%,79%)",
            "hsl": [
                200,
                52,
                79
            ],
            "rgb": "#afd4e6"
        },
        {
            "name": "CC-820 Airway",
            "value": "hsl(211,31%,78%)",
            "hsl": [
                211,
                31,
                78
            ],
            "rgb": "#b5c6d8"
        },
        {
            "name": "CC-730 Blue Stream",
            "value": "hsl(193,26%,76%)",
            "hsl": [
                193,
                26,
                76
            ],
            "rgb": "#b1cad1"
        },
        {
            "name": "CC-816 Athabasca",
            "value": "hsl(202,17%,74%)",
            "hsl": [
                202,
                17,
                74
            ],
            "rgb": "#b2c0c8"
        },
        {
            "name": "CC-940 Blue Viola",
            "value": "hsl(226,22%,74%)",
            "hsl": [
                226,
                22,
                74
            ],
            "rgb": "#adb4cb"
        },
        {
            "name": "CC-878 H2O",
            "value": "hsl(205,39%,74%)",
            "hsl": [
                205,
                39,
                74
            ],
            "rgb": "#a2c0d6"
        },
        {
            "name": "CC-786 Summer Day",
            "value": "hsl(203,54%,74%)",
            "hsl": [
                203,
                54,
                74
            ],
            "rgb": "#98c4e0"
        },
        {
            "name": "CC-908 Frozen Canal",
            "value": "hsl(213,29%,73%)",
            "hsl": [
                213,
                29,
                73
            ],
            "rgb": "#a6b8ce"
        },
        {
            "name": "CC-760 Northern Air",
            "value": "hsl(201,32%,72%)",
            "hsl": [
                201,
                32,
                72
            ],
            "rgb": "#a1bfcf"
        },
        {
            "name": "CC-906 Summer Mist",
            "value": "hsl(215,36%,72%)",
            "hsl": [
                215,
                36,
                72
            ],
            "rgb": "#9eb3d1"
        },
        {
            "name": "CC-904 Cascade",
            "value": "hsl(215,51%,71%)",
            "hsl": [
                215,
                51,
                71
            ],
            "rgb": "#8eaeda"
        },
        {
            "name": "CC-970 Heather Field",
            "value": "hsl(240,15%,70%)",
            "hsl": [
                240,
                15,
                70
            ],
            "rgb": "#a7a7be"
        },
        {
            "name": "CC-814 Glace Bay",
            "value": "hsl(205,29%,70%)",
            "hsl": [
                205,
                29,
                70
            ],
            "rgb": "#9bb5c8"
        },
        {
            "name": "CC-920 Yukon Sky",
            "value": "hsl(224,13%,67%)",
            "hsl": [
                224,
                13,
                67
            ],
            "rgb": "#a1a7b7"
        },
        {
            "name": "CC-818 Early Morning",
            "value": "hsl(199,19%,67%)",
            "hsl": [
                199,
                19,
                67
            ],
            "rgb": "#9cb2bc"
        },
        {
            "name": "CC-784 Clear Sailing",
            "value": "hsl(199,46%,67%)",
            "hsl": [
                199,
                46,
                67
            ],
            "rgb": "#84b9d1"
        },
        {
            "name": "CC-890 Blue Pearl",
            "value": "hsl(221,24%,66%)",
            "hsl": [
                221,
                24,
                66
            ],
            "rgb": "#94a1be"
        },
        {
            "name": "CC-936 Citadel",
            "value": "hsl(213,25%,66%)",
            "hsl": [
                213,
                25,
                66
            ],
            "rgb": "#94a7bf"
        },
        {
            "name": "CC-812 Five Dollar Bill",
            "value": "hsl(206,34%,63%)",
            "hsl": [
                206,
                34,
                63
            ],
            "rgb": "#82a6c1"
        },
        {
            "name": "CC-770 Denim Wash",
            "value": "hsl(207,25%,62%)",
            "hsl": [
                207,
                25,
                62
            ],
            "rgb": "#86a1b7"
        },
        {
            "name": "CC-740 Labrador Blue",
            "value": "hsl(200,22%,59%)",
            "hsl": [
                200,
                22,
                59
            ],
            "rgb": "#809ead"
        },
        {
            "name": "CC-876 Mariner's Tale",
            "value": "hsl(212,32%,56%)",
            "hsl": [
                212,
                32,
                56
            ],
            "rgb": "#6c8eb4"
        },
        {
            "name": "CC-950 Queen's Wreath",
            "value": "hsl(231,15%,55%)",
            "hsl": [
                231,
                15,
                55
            ],
            "rgb": "#7d829e"
        },
        {
            "name": "CC-830 Stratford Blue",
            "value": "hsl(219,19%,55%)",
            "hsl": [
                219,
                19,
                55
            ],
            "rgb": "#7786a2"
        },
        {
            "name": "CC-846 Lazy Sunday",
            "value": "hsl(207,38%,55%)",
            "hsl": [
                207,
                38,
                55
            ],
            "rgb": "#5f90b7"
        },
        {
            "name": "CC-980 Purple Haze",
            "value": "hsl(249,8%,54%)",
            "hsl": [
                249,
                8,
                54
            ],
            "rgb": "#838093"
        },
        {
            "name": "CC-902 Waterdrop",
            "value": "hsl(220,37%,54%)",
            "hsl": [
                220,
                37,
                54
            ],
            "rgb": "#5d7ab4"
        },
        {
            "name": "CC-934 In the Twilight",
            "value": "hsl(222,12%,52%)",
            "hsl": [
                222,
                12,
                52
            ],
            "rgb": "#757e93"
        },
        {
            "name": "CC-750 West Coast",
            "value": "hsl(199,17%,51%)",
            "hsl": [
                199,
                17,
                51
            ],
            "rgb": "#6c8996"
        },
        {
            "name": "CC-800 Blue Nose",
            "value": "hsl(204,24%,51%)",
            "hsl": [
                204,
                24,
                51
            ],
            "rgb": "#6488a0"
        },
        {
            "name": "CC-930 Amethyst Shadow",
            "value": "hsl(231,8%,47%)",
            "hsl": [
                231,
                8,
                47
            ],
            "rgb": "#6f7283"
        },
        {
            "name": "CC-960 French Violet",
            "value": "hsl(232,12%,47%)",
            "hsl": [
                232,
                12,
                47
            ],
            "rgb": "#6a6e87"
        },
        {
            "name": "CC-860 Blue Nova",
            "value": "hsl(220,23%,47%)",
            "hsl": [
                220,
                23,
                47
            ],
            "rgb": "#5c6e93"
        },
        {
            "name": "CC-840 Blue Heron",
            "value": "hsl(220,18%,45%)",
            "hsl": [
                220,
                18,
                45
            ],
            "rgb": "#5d6b86"
        },
        {
            "name": "CC-844 Winter's Eve",
            "value": "hsl(207,41%,44%)",
            "hsl": [
                207,
                41,
                44
            ],
            "rgb": "#41739d"
        },
        {
            "name": "CC-782 Georgian Bay",
            "value": "hsl(202,23%,43%)",
            "hsl": [
                202,
                23,
                43
            ],
            "rgb": "#547385"
        },
        {
            "name": "CC-874 Mosaic",
            "value": "hsl(216,48%,43%)",
            "hsl": [
                216,
                48,
                43
            ],
            "rgb": "#3963a4"
        },
        {
            "name": "CC-900 Blue Gaspe",
            "value": "hsl(225,11%,41%)",
            "hsl": [
                225,
                11,
                41
            ],
            "rgb": "#5d6375"
        },
        {
            "name": "CC-780 Kensington Blue",
            "value": "hsl(216,20%,37%)",
            "hsl": [
                216,
                20,
                37
            ],
            "rgb": "#4c5b72"
        },
        {
            "name": "CC-968 Basic Blue",
            "value": "hsl(234,33%,37%)",
            "hsl": [
                234,
                33,
                37
            ],
            "rgb": "#40467e"
        },
        {
            "name": "CC-872 Delphinium",
            "value": "hsl(221,48%,37%)",
            "hsl": [
                221,
                48,
                37
            ],
            "rgb": "#314d8a"
        },
        {
            "name": "CC-966 Wizard",
            "value": "hsl(232,26%,34%)",
            "hsl": [
                232,
                26,
                34
            ],
            "rgb": "#41476e"
        },
        {
            "name": "CC-810 Hudson Bay",
            "value": "hsl(211,23%,33%)",
            "hsl": [
                211,
                23,
                33
            ],
            "rgb": "#405367"
        },
        {
            "name": "CC-870 Jet Blue",
            "value": "hsl(224,20%,32%)",
            "hsl": [
                224,
                20,
                32
            ],
            "rgb": "#424b63"
        },
        {
            "name": "CC-964 Blue Grotto",
            "value": "hsl(235,30%,30%)",
            "hsl": [
                235,
                30,
                30
            ],
            "rgb": "#363a64"
        },
        {
            "name": "CC-962 Blackberry Punch",
            "value": "hsl(233,12%,28%)",
            "hsl": [
                233,
                12,
                28
            ],
            "rgb": "#404251"
        },
        {
            "name": "CC-842 Mistral",
            "value": "hsl(202,76%,28%)",
            "hsl": [
                202,
                76,
                28
            ],
            "rgb": "#11567e"
        },
        {
            "name": "CC-932 North Sea",
            "value": "hsl(211,27%,24%)",
            "hsl": [
                211,
                27,
                24
            ],
            "rgb": "#2c3c4d"
        },
        {
            "name": "CC-38 Nightfall Sky",
            "value": "hsl(272,9%,44%)",
            "hsl": [
                272,
                9,
                44
            ],
            "rgb": "#706679"
        },
        {
            "name": "CC-4 Camelot",
            "value": "hsl(332,10%,34%)",
            "hsl": [
                332,
                10,
                34
            ],
            "rgb": "#5e4d55"
        },
        {
            "name": "CC-990 Super Nova",
            "value": "hsl(261,8%,33%)",
            "hsl": [
                261,
                8,
                33
            ],
            "rgb": "#524d5b"
        },
        {
            "name": "CC-34 Jester",
            "value": "hsl(333,25%,29%)",
            "hsl": [
                333,
                25,
                29
            ],
            "rgb": "#5b3747"
        },
        {
            "name": "CC-36 Peerage",
            "value": "hsl(297,15%,28%)",
            "hsl": [
                297,
                15,
                28
            ],
            "rgb": "#503c51"
        }
    ];
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/BenjaminMoore_DesignerClassics_en-us.js
// module id = 63
// module chunks = 0